import { render, staticRenderFns } from "./PropertyControl.vue?vue&type=template&id=06a530a2&"
import script from "./PropertyControl.vue?vue&type=script&lang=js&"
export * from "./PropertyControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports